import styled from "styled-components";

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  overflow-x: auto;
  padding: 0.75rem 1.5rem 0.75rem 0.5rem;
  scrollbar-width: thin;
  border-bottom: 1px solid #f3c2d1;
  background: #fff;
  min-height: 3rem;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    height: 0.5rem;
    background: #f9e6ee;
  }
  &::-webkit-scrollbar-thumb {
    background: #f3c2d1;
    border-radius: 0.25rem;
  }
`;

export const PageArrow = styled.button<{ disabled?: boolean }>`
  background: none;
  border: none;
  color: ${(props) => (props.disabled ? "#ccc" : "#fe2f67")};
  font-size: 1rem;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  padding: 0.3rem 0.7rem;
  white-space: nowrap;

  &:hover {
    background: ${(props) => (props.disabled ? "none" : "#ffe9ef")};
  }
`;

export const PageNumber = styled.button<{ isActive?: boolean }>`
  background: ${(props) => (props.isActive ? "#fe2f67" : "none")};
  border: 1px solid #fe2f67;
  color: ${(props) => (props.isActive ? "#fff" : "#fe2f67")};
  cursor: pointer;
  padding: 0.3rem 0.7rem;
  border-radius: 0.25rem;
  font-size: 1rem;

  &:hover {
    background: #fe2f67;
    color: #fff;
  }
`;